export default __webpack_public_path__ + "static/media/revenue_dashboard.9224bb2b.svg";